export default function add(x = 0, y = 0) {
  return x + y;
};